import { useState } from "react";
import { Button, Form, Offcanvas } from "react-bootstrap";
import { useEffect } from "react";
import Swal from "sweetalert2";
import { accountServices } from "../../../../APIServices/PasswordManagement/accountServices";

const UpdateAccount = ({ auth, Show, Hide, Title, isDark, getAccountList, setUpdator, accountData, PermanentDeleteAccount }) => {
  const [accountName, setAccountName] = useState("");
  const [description, setDescription] = useState("");
  const [status, setStatus] = useState("");
  const [loader, setLoader] = useState(false);

  const updatedAccount = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to update this account?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {}
        setLoader(true)
        userData.accountId = accountData?.accountId
        userData.name = accountName
        userData.description = description
        userData.status = status
        let data = await accountServices.updatedAccount(auth, userData)
        if (data?.statusCode === 200) {
          getAccountList()
          setUpdator(`accountList_${Math.floor(10000 + Math.random() * 90000)}`);
          Hide()
        }
        setLoader(false)
      }
    });
  };

  useEffect(() => {
    if (accountData) {
      setAccountName(accountData?.name)
      setDescription(accountData?.description)
      setStatus(accountData?.status)
    }
  }, [accountData]);

  return (
    <Offcanvas show={Show} onHide={Hide} placement="end">
      <Offcanvas.Header closeButton className={`${isDark ? "bg-dark" : "bg-light"} p-3 border-bottom`}>
        <Offcanvas.Title className="fw-bold" style={{ fontSize: 15 }}>
          {Title}
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Form.Group className="mb-2">
          <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
            Status{" "}
            <abbr className="text-danger" title="Require">
              *
            </abbr>
          </Form.Label>
          <Form.Select
            className="interactive-input"
            style={{ fontSize: 12, padding: "6px 15px" }}
            onChange={(e) => setStatus(e.target.value)}
            value={status}
          >
            <option value="">Seelct Status</option>
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </Form.Select>
        </Form.Group>
        <Form.Group className="mb-2">
          <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
            Account Name{" "}
            <abbr className="text-danger" title="Require">
              *
            </abbr>
          </Form.Label>
          <Form.Control
            type="text"
            value={accountName}
            onChange={(e) => setAccountName(e.target.value)}
            className="interactive-input rounded-1"
            style={{ fontSize: 12, padding: "6px 15px" }}
            placeholder="Enter Account Name"
          />
        </Form.Group>
        <Form.Group className="mb-2">
          <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
            Description (optional)
          </Form.Label>
          <Form.Control
            as="textarea"
            rows={5}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            className="interactive-input rounded-1"
            style={{ fontSize: 12, padding: "6px 15px" }}
            placeholder="What should this account use for?"
          />
        </Form.Group>
      </Offcanvas.Body>
      <div className={`${isDark ? "bg-dark" : "bg-light"} p-2 border-top ${(!accountData?.loginStatus && accountData?.category === "secondary") ? "hstack justify-content-between" : "text-end"}`}>
        {(!accountData?.loginStatus && accountData?.category === "secondary") &&
          <Button
            variant="outline-danger"
            style={{ fontSize: 13 }}
            className="rounded-1 py-1 px-3"
            title="Permanent Delete Account"
            onClick={() => { PermanentDeleteAccount(); Hide() }}
          >
            Permanent Delete Account
          </Button>
        }
        <Button
          variant="outline-primary"
          disabled={!status || !accountName || loader}
          onClick={updatedAccount}
          style={{ fontSize: 13 }}
          className="rounded-1 py-1 px-3"
          title={Title}
        >
          {Title}
        </Button>
      </div>
    </Offcanvas>
  );
};

export default UpdateAccount;
